import React from 'react';
import { LabelInput } from '@/components/ui/inputs/LabelInput';
import type { InputColor } from '@/components/ui/inputs/Input.types';
import { IconScout } from '@/components/ui/images/IconScout';
import { colors } from '@/assets/styles/colors';


interface DateInputProps {
  label?: string;
  value: string;
  onClick?: () => void;
  placeholder?: string;
  color?: InputColor;
  supportingText?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  iconColor?: string;
}

/**
 * Unified date input trigger component for DatePicker and DateRangePicker
 * Always displays a calendar icon on the right
 */
export const DateInput: React.FC<DateInputProps> = ({
  label,
  value,
  onClick,
  placeholder = 'dd/mm/aaaa',
  color,
  supportingText,
  className = '',
  disabled = false,
  required = false,
  iconColor = colors.important.main,
}) => {
  const calendarIcon = (
    <IconScout name="calendarAlt" color={iconColor} size="md" />
  );

  return (
    <div className={className} onClick={disabled ? undefined : onClick}>
      <LabelInput
        color={color}
        label={label}
        value={value}
        readOnly
        disabled={disabled}
        required={required}
        onChange={() => {}}
        iconRight={calendarIcon}
        fullWidth
        placeholder={placeholder}
        supportingText={supportingText}
      />
    </div>
  );
};
